import { Box, useTheme } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MainContainer } from "../../../components/container/MainContainer";
import SegmentedTabs from "../../../components/tabs/SegmentedTabs";
import { getOrgTokens } from "../../../theme/style/organizationPalette";
import EPDLifeCycleAssessment from "../../../sidemenu-pages/sidemenu-components/EPDLifeCycleAssessment";
import EPDPlot from "../../../sidemenu-pages/sidemenu-components/EPDPlot";
import EPDTable from "../../../sidemenu-pages/sidemenu-components/EPDTable";

const EPD = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const tok = getOrgTokens(isDark);
  const [gwpValues, setGwpValues] = useState([]);
  const [isBoxplotView, setIsBoxplotView] = useState(false);
  const [firstSelectedRowData, setFirstSelectedRowData] = useState([]);
  const product = { label: "Product", value: "product" };
  const project = { label: "Project", value: "project" };
  const building = { label: "Building", value: "building" };
  const supply_chain = { label: "Supply Chain", value: "supply_chain" };
  const organization = { label: "Organization", value: "organization" };
  const tabs = [product, project, building, supply_chain, organization];
  const [selectedTab, setSelectedTab] = useState(product.value);

  function calculateStandardDeviation(values) {
    if (values.length === 0) {
      return 0;
    }
    const mean = values.reduce((a, b) => a + b, 0) / values.length;
    return Math.sqrt(values.map((x) => Math.pow(x - mean, 2)).reduce((a, b) => a + b, 0) / values.length);
  }

  return (
    <MainContainer>
      <Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 3,
        gap: 3
      }}>
        <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
          <Box sx={{ width: "100%", maxWidth: "800px" }}>
            <SegmentedTabs
              options={tabs}
              selected={selectedTab}
              setSelected={setSelectedTab}
              activeColor={tok.bg.tabActive}
            />
          </Box>
        </Box>
      </Box>
      <Box sx={{ paddingY: 1 }} />
      {selectedTab === product.value && (
        <Box>
          <Box>
            <EPDTable
              setGwpValues={setGwpValues}
              setIsBoxplotView={setIsBoxplotView}
              calculateStandardDeviation={calculateStandardDeviation}
              setFirstSelectedRow={setFirstSelectedRowData}
            />
            {isBoxplotView && <EPDPlot gwpValues={gwpValues} calculateStandardDeviation={calculateStandardDeviation} />}
          </Box>
          {firstSelectedRowData && (Array.isArray(firstSelectedRowData) ? firstSelectedRowData.length > 0 : true) && (
            <Box>
              <Box sx={{ paddingY: 2 }} />
              <EPDLifeCycleAssessment firstSelectedRowData={firstSelectedRowData} />
            </Box>
          )}
        </Box>
      )}
    </MainContainer>
  );
};
export default EPD;
